import * as React from "react";
import { Box, Typography } from "@mui/material";
import { COMPANY_NAME } from "../../config/constants";
import originLogo from "../../config/assets/origin-original-logo.png";
import ThemeColors from "../../config/colors";
import { useTranslation } from "react-i18next";

const CustomDrawerFooter = () => {
    const { t } = useTranslation()
    return (
        <Box
            className="d-flex justify-content-center align-items-center p-2"
        >
            <Typography variant="body2">
                {t('Powered by')}

            </Typography>
            <Box
                component='img'
                alt={COMPANY_NAME}
                sx={{
                    width: { xs: '35%' },
                    px: 1
                }}
                src={originLogo}
            />
            <Typography variant="subtitle1">
                {process.env.REACT_APP_VERSION}
            </Typography>
        </Box>
    );
};

export default CustomDrawerFooter;
